import Analytics from "./util/Analytics";

import { GET_INTEREST_MATCHES_SUCCESS } from "ducks/discovery";

export default function discovery(state, action) {
	switch (action.type) {
		case GET_INTEREST_MATCHES_SUCCESS: {
			const { row } = action.payload;

			Analytics.logUIEvent(Analytics.eventNames.discoverySearchedInterest, {
				data: {
					interest: row.title,
					result_size: row.data.length,
				},
			});

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/discovery.js